import { User } from "@auth0/auth0-react";
import { useUnleashContext } from "@unleash/proxy-client-react";
import { useEffect } from "react";

export const useUpdateUnleashContext = ({
  user
}: {
  user: User | undefined;
}) => {
  const updateContext = useUnleashContext();

  useEffect(() => {
    if (user?.email) {
      updateContext({ properties: { email: user.email } }).catch((err) =>
        console.error(err)
      );
    }
  }, [updateContext, user?.email]);
};
